import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import logoTerrioBlanco from '../../Map/assets/Logo-Terrio-blanco.png';
import { colors, typography } from '../../styles/theme';

const primaryContainedButtonSx = {
  textTransform: 'none',
  px: 2.5,
  py: 1,
  fontSize: '13px',
  fontWeight: 600,
  borderRadius: 1.5,
  bgcolor: colors.primary,
  color: '#ffffff',
  boxShadow: 'none',
  fontFamily: typography.fontFamily.primary,
  '&:hover': {
    bgcolor: colors.primaryHover,
    boxShadow: 'none',
  },
};

const secondaryOutlinedButtonSx = {
  textTransform: 'none',
  px: 2.5,
  py: 1,
  fontSize: '13px',
  fontWeight: 500,
  borderRadius: 1.5,
  color: '#9ca3af',
  borderColor: 'rgba(255,255,255,0.15)',
  fontFamily: typography.fontFamily.primary,
  '&:hover': {
    borderColor: 'rgba(255,255,255,0.28)',
    bgcolor: 'transparent',
    color: '#d1d5db',
  },
};

const fadeUpKeyframes = `
  @keyframes terrioErrorFadeUp {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

export default function ErrorFallback({ errorReferenceId, onReset }) {
  const navigate = useNavigate();

  const handleGoHome = () => {
    onReset();
    navigate('/app', { replace: true });
  };

  const handleReload = () => {
    window.location.assign('#/app');
    window.location.reload();
  };

  return (
    <>
      <style>{fadeUpKeyframes}</style>
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999,
          bgcolor: '#0f0f0f',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 420,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            animation: 'terrioErrorFadeUp 0.4s ease both',
          }}
        >
          {/* Logo */}
          <Box
            component="img"
            src={logoTerrioBlanco}
            alt="Terrio"
            sx={{ width: 110, height: 'auto', opacity: 0.9, mb: 3.5 }}
          />


          {/* Título */}
          <Typography
            sx={{
              color: '#f9fafb',
              fontFamily: typography.fontFamily.heading,
              fontSize: { xs: '20px', sm: '22px' },
              fontWeight: 600,
              lineHeight: 1.3,
              mb: 1.5,
            }}
          >
            Algo salió mal
          </Typography>

          {/* Descripción */}
          <Typography
            sx={{
              color: '#6b7280',
              fontFamily: typography.fontFamily.primary,
              fontSize: '13.5px',
              lineHeight: 1.65,
              maxWidth: 320,
              mb: errorReferenceId ? 1.5 : 3,
            }}
          >
            No pudimos cargar esta pantalla. El problema fue registrado
            automáticamente.
          </Typography>

          {/* Referencia */}
          {errorReferenceId && (
            <Box
              sx={{
                display: 'inline-block',
                bgcolor: 'rgba(255,255,255,0.05)',
                border: '0.5px solid rgba(255,255,255,0.08)',
                borderRadius: '6px',
                px: 1.25,
                py: 0.5,
                mb: 3,
              }}
            >
              <Typography
                sx={{
                  color: '#4b5563',
                  fontFamily: "'SF Mono', ui-monospace, monospace",
                  fontSize: '11px',
                  letterSpacing: '0.06em',
                }}
              >
                REF: {errorReferenceId}
              </Typography>
            </Box>
          )}

          {/* Acciones */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 1.25,
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              onClick={handleGoHome}
              sx={primaryContainedButtonSx}
            >
              Ir al inicio
            </Button>
            <Button
              variant="outlined"
              onClick={handleReload}
              sx={secondaryOutlinedButtonSx}
            >
              Recargar
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}